import React, {Component} from "react";
import applogic from "../applogic.js";

class LoginForm extends Component {
    handleLoginButtonClick(e) {
        applogic.handleLoginButtonClick(this.matric, this.password);
    }

    onMatricChange(e) {
        this.matric = e.target.value;
    }

    onPasswordChange(e) {
        this.password = e.target.value;
    }

    render() {
        return (
            <div className="login-form container-fluid">
                <form className="row" onSubmit={e => e.preventDefault()}>
                    <div className="form-group col-lg-4 px-2">
                        <input type="text" name="matric" className="form-control form-control-lg"
                               placeholder="NUSNET ID" autoFocus="true" onChange={this.onMatricChange.bind(this)}/>
                    </div>
                    <div className="form-group col-lg-4 px-2">
                        <input type="password" className="form-control form-control-lg" name="password"
                               placeholder="Password" onChange={this.onPasswordChange.bind(this)}/>
                    </div>
                    <div className="form-group col-lg-4 px-2">
                        <button className="btn btn-primary btn-lg btn-block"
                                data-dismiss={this.props.isModal && "modal"}
                                onClick={this.handleLoginButtonClick.bind(this)}>Login (via IVLE)
                        </button>
                    </div>
                </form>
                <div className="col-lg-12 text-center">
                    <a href="#" className="modal-token" data-toggle="modal"
                       data-target="#modalToken">
                        In case you don't feel comfortable entering your password above, click here for the troublesome alternative way of login...
                    </a>
                </div>
            </div>
        );
    }
}
export default LoginForm;


// WEBPACK FOOTER //
// ./src/componentsBody/LoginForm.js